<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-file-input
          accept=".p12"
          @change="updateFile"
          label="Certifikat *"
        ></v-file-input>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.certificate.required)"
        >
          <FormErrorsLine v-if="!$v.form.certificate.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.password"
          label="Geslo *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.password.required)"
        >
          <FormErrorsLine v-if="!$v.form.password.required" text="Polje je obvezno" />
        </FormErrors>
        <v-btn type="submit" class="float-right" :disabled="loading">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    certificate: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      file: null,
      form: {
        password: null,
        filename: null,
        certificate: null
      }
    }
  },
  validations: {
    form: {
      password: {
        required
      },
      certificate: {
        required
      }
    }
  },
  methods: {
    updateFile (file) {
      if (file) {
        this.form.filename = file.name
        this.loading = true
        this.fileToBase64(file)
          .then(base64 => {
            this.loading = false
            this.form.certificate = base64
          })
      } else {
        this.form.filename = ''
        this.form.certificate = ''
      }
    },
    fileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.split(',')[1])
        reader.onerror = error => reject(error)
      })
    },
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.form, ...this.certificate }
  }
}
</script>
